// src/pages/LandingPage.tsx
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import classes from "./CountrySelection.module.css";
import { useNavigate } from "react-router-dom";
import { changeLanguage, t } from "i18next";
import { countries, Country, getInitialLanguage } from "./CountriesData";

export const CountrySelection = () => {
  const { i18n } = useTranslation();
  const detectedLanguage = getInitialLanguage(i18n.language);

  const [, setCurrentLanguage] = useState<Country>(detectedLanguage);
  // Update session storage whenever username changes
  useEffect(() => {
    sessionStorage.setItem("country", detectedLanguage.countryCode ?? "");
    sessionStorage.setItem("countryId", detectedLanguage.id ?? "");
  }, [detectedLanguage]);

  return (
    <>
      <h1 className={classes.title}>{t("welcome")}</h1>
      <div className={classes.container}>
        <h2 className={classes.heading}>Select your country</h2>

        {Object.keys(countries).map((key) => (
          <LanguageGroup
            key={key}
            title={key}
            countries={countries[key]}
            setCurrentLanguage={setCurrentLanguage}
          ></LanguageGroup>
        ))}
      </div>
    </>
  );
};

interface LanguageGroupProps {
  title: string;
  countries: Country[];
  setCurrentLanguage: (value: Country) => void;
}
const LanguageGroup: React.FC<LanguageGroupProps> = ({
  title,
  countries,
  setCurrentLanguage,
}) => {
  const navigate = useNavigate();
  return (
    <>
      <h4 className={classes.regionTitle}>{title}</h4>
      <div className={classes.countriesGrid}>
        {countries.map((country) => (
          <div
            className={classes.countryButton}
            onClick={() => {
              setCurrentLanguage(country);
              changeLanguage(country.id);
              navigate("/landing");
            }}
            key={country.label}
          >
            <img
              src={country.img}
              alt={country.label}
              className={classes.flag}
            />
            <p>{country.label}</p>
          </div>
        ))}
      </div>
    </>
  );
};
